import React from 'react';

const Idea = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2554 15.8718H9.20413V17.6667V18.4615C9.20413 19.0138 9.65184 19.4615 10.2041 19.4615H10.2298H12.2811H12.3067C12.859 19.4615 13.3067 19.0138 13.3067 18.4615V15.8718H11.2554Z"
        fill="#2D293B"
      />
      <path
        d="M10.2298 19.4615V19.9744C10.2298 20.5408 10.689 21 11.2554 21C11.8219 21 12.2811 20.5408 12.2811 19.9744V19.4615H10.2298Z"
        fill="#2D293B"
      />
      <path
        d="M9.20413 15.8718H11.2554H13.3067M9.20413 15.8718V15.8718C8.63768 15.8718 8.17849 15.4126 8.17849 14.8462V14.2016C8.17849 13.6431 7.89138 13.1289 7.48801 12.7427C6.43396 11.7335 5.10156 9.799 5.10156 7.15385C5.10156 3.05128 8.17849 1 11.2554 1C14.3323 1 17.4093 3.05128 17.4093 7.15385C17.4093 9.799 16.0769 11.7335 15.0228 12.7427C14.6194 13.1289 14.3323 13.6431 14.3323 14.2016V14.8462C14.3323 15.4126 13.8731 15.8718 13.3067 15.8718V15.8718M9.20413 15.8718V17.6667M13.3067 15.8718V18.4615C13.3067 19.0138 12.859 19.4615 12.3067 19.4615H12.2811M9.20413 17.6667V18.4615C9.20413 19.0138 9.65184 19.4615 10.2041 19.4615H10.2298M9.20413 17.6667H11.7682M10.2298 19.4615V19.9744C10.2298 20.5408 10.689 21 11.2554 21V21C11.8219 21 12.2811 20.5408 12.2811 19.9744V19.4615M10.2298 19.4615H12.2811"
        stroke="#8686F1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2412 13.3074C10.2412 13.5283 10.4203 13.7074 10.6412 13.7074C10.8621 13.7074 11.0412 13.5283 11.0412 13.3074H10.2412ZM11.472 13.3074C11.472 13.5283 11.6511 13.7074 11.872 13.7074C12.0929 13.7074 12.272 13.5283 12.272 13.3074H11.472ZM11.0412 13.3074V7.3587H10.2412V13.3074H11.0412ZM9.37627 8.92109H11.2748V8.12109H9.37627V8.92109ZM12.272 13.3074V8.52109H11.472V13.3074H12.272ZM12.272 8.52109V7.32451H11.472V8.52109H12.272ZM13.1028 8.12109H11.872V8.92109H13.1028V8.12109ZM11.872 8.12109H11.2748V8.92109H11.872V8.12109ZM13.9335 7.32451C13.9335 7.7539 13.5723 8.12109 13.1028 8.12109V8.92109C13.9927 8.92109 14.7335 8.21683 14.7335 7.32451H13.9335ZM13.1028 6.52793C13.5723 6.52793 13.9335 6.89512 13.9335 7.32451H14.7335C14.7335 6.4322 13.9927 5.72793 13.1028 5.72793V6.52793ZM12.272 7.32451C12.272 6.89512 12.6332 6.52793 13.1028 6.52793V5.72793C12.2128 5.72793 11.472 6.4322 11.472 7.32451H12.272ZM9.41046 5.72793H9.37627V6.52793H9.41046V5.72793ZM7.77969 7.32451C7.77969 8.20628 8.4945 8.92109 9.37627 8.92109V8.12109C8.93633 8.12109 8.57969 7.76445 8.57969 7.32451H7.77969ZM8.57969 7.32451C8.57969 6.88457 8.93633 6.52793 9.37627 6.52793V5.72793C8.4945 5.72793 7.77969 6.44274 7.77969 7.32451H8.57969ZM11.0412 7.3587C11.0412 6.45805 10.3111 5.72793 9.41046 5.72793V6.52793C9.86928 6.52793 10.2412 6.89988 10.2412 7.3587H11.0412Z"
        fill="#8686F1"
      />
      <path
        d="M2.53906 12.2832L3.5647 11.7704"
        stroke="#8686F1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 7.1543H2.53846"
        stroke="#8686F1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.05469 2.53906L2.02905 2.02624"
        stroke="#8686F1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4609 12.2832L18.4353 11.7704"
        stroke="#8686F1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 7.1543H19.4615"
        stroke="#8686F1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9453 2.53906L19.971 2.02624"
        stroke="#8686F1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Idea;
